import { render, staticRenderFns } from "./CheckoutNavigation.vue?vue&type=template&id=b4cfdf1a&"
import script from "./CheckoutNavigation.vue?vue&type=script&lang=js&"
export * from "./CheckoutNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports